import { render, staticRenderFns } from "./table-audit.vue?vue&type=template&id=5a1040b8&"
import script from "./table-audit.vue?vue&type=script&lang=ts&"
export * from "./table-audit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports